import React from 'react';

import { WorkTemplatesView } from '@atom/hooks/useWorkTemplatesView';

interface Context {
  activeFolderId: string;
  setActiveFolderId: React.Dispatch<React.SetStateAction<string>>;
  open: Set<string>;
  toggleOpen: (id: string) => void;
  refetchWorkTemplateFolderTree: () => Promise<void>;
  isActiveFolderLeafNode: boolean;
  setIsActiveFolderLeafNode: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  limit: number;
  setWorkTemplatesView: (input: Partial<WorkTemplatesView>) => void;
}

export const initialState: Context = {
  activeFolderId: 'workTypes',
  setActiveFolderId: () => {},
  open: new Set(['workTypes']),
  toggleOpen: () => {},
  refetchWorkTemplateFolderTree: () => Promise.resolve(),
  isActiveFolderLeafNode: false,
  setIsActiveFolderLeafNode: () => {},
  page: null,
  limit: null,
  setWorkTemplatesView: () => {},
};

const WorkTemplatesContext = React.createContext<Context>(initialState);

export default WorkTemplatesContext;
